import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { USER_INIT } from './constants';
import {
  UserInitSuccess,
  UserInitError,
  UserInitActionTypes,
  IUserInitState,
} from './types';

const initialState: IUserInitState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (draft = initialState, action: UserInitActionTypes): IUserInitState => {
    switch (action.type) {
      case USER_INIT + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case USER_INIT + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as UserInitSuccess).payload;
        break;
      }
      case USER_INIT + FAILURE: {
        draft.status = rejected;
        draft.error = (action as UserInitError).error;
        break;
      }
      case USER_INIT + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
